export default __webpack_public_path__ + "static/media/gameOver.f52cf5f0.mp3";